import { render, staticRenderFns } from "./CrewAdd.vue?vue&type=template&id=10e25e2c"
import script from "./CrewAdd.vue?vue&type=script&lang=js"
export * from "./CrewAdd.vue?vue&type=script&lang=js"
import style0 from "./CrewAdd.vue?vue&type=style&index=0&id=10e25e2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports